import { ListOrderRequest, OrderFront } from "@project/shared-types";
import { useEffect, useRef, useState } from "react";
import LoginSvg from "../../../assets/taiga-uikit/icons/login.svg?react";
import { Button } from "../../../components/button/button";
import Dropdown from "../../../components/Dropdown/Dropdown";
import { Loader } from "../../../components/Loader/Loader";
import { TabSelection } from "../../../components/TabSelection/TabSelection";
import { Text } from "../../../components/texts/text";
import Title from "../../../components/texts/title";
import { _size, _sizeHeading, _sizeText, _style } from "../../../core/core";
import { PreviewNotifly } from "../../../entities/notifly/ui/PreviewNotifly";
import { ListOrderAPI } from "../../../entities/order/model/order.api";
import { OrderCardPreview } from "../../../entities/order/ui/OrderCardPreview/OrderCardPreview";
import { useData } from "../../../entities/service/model/DataContext";
import { useUser } from "../../../entities/user/hooks/useUser";
import { useLocalStorage } from "../../../shared/hooks/useLocalStorage";
import "./OrdersList.css";
export const OrdersList = ({ ...props }) => {
  const breadLinks = [
    { url: "/", name: "Главная" },
    { url: "/account/", name: "Профиль" },
  ];
  const [orders, setOrders] = useLocalStorage<OrderFront[]>("orders_v4", []);
  const [selected, setSelected] = useLocalStorage<boolean>(
    "order_selected",
    true
  );
  const [isLoading, setIsLoading] = useState(false);
  const user = useUser();
  const loading = useRef(false);
  const { products } = useData();

  useEffect(() => {
    if (!user && typeof window !== "undefined") {
      window.location.href = '/account/login/';
    }
  }, [user]);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        if (isLoading) return;
        setIsLoading(true);

        var data_req = {
          is_actual: selected,
        } as ListOrderRequest;
        const response = await ListOrderAPI(data_req); // Замените '/api/service-previews' на ваше API-оконечное точка для получения карточек услуг

        if (response.orders) {
          setOrders(response.orders);
        }
        setIsLoading(false);
      } catch (e) {
        console.error("Ошибка при получении карточек услуг:", e);
      }
    };
    if (loading.current) return;
    loading.current = true;
    fetchOrders();
    loading.current = false;
  }, [user, selected]);

  const logout = () => {
    localStorage.removeItem("user_auth");
    localStorage.removeItem("token");
    if (typeof window !== "undefined") {
      window.location.href = "/account/logout/";
    }
  };
  return (
    <div className={"main-account "}>
      <div className="bread">
        <Text size={_sizeText.s}>{user?.email}</Text>
        <div className="main-account-exit">
          <Button
            style={_style.link}
            onClick={logout}
            size={_size.S}
            icon_right={<LoginSvg></LoginSvg>}
          >
            Выйти из аккаунта
          </Button>
        </div>
      </div>
      <div className="main-account-block">
        <PreviewNotifly />
        <div className="main-account-body">
          <div className="main-account-filtres">
            <Title type={_sizeHeading.h3}>Мои заказы </Title>
            <Dropdown
              mobile
              onSelect={(id: boolean) => setSelected(id)}
              options={[
                { label: "Активные", id: true },
                { label: "Архив", id: false },
              ]}
            >
              <Text size={_sizeText.m}>{selected ? "Активные" : "Архив"}</Text>
            </Dropdown>
            <div className="main-account-filtres-body">
              <TabSelection
                onClick={() => setSelected(true)}
                isActive={selected === true}
              >
                Активные
              </TabSelection>
              <TabSelection
                onClick={() => setSelected(false)}
                isActive={selected === false}
              >
                Архив
              </TabSelection>
            </div>
          </div>
          <div className="main-account-list">
            {isLoading ? (
              <Loader isLoading></Loader>
            ) : (
              <>
                {orders.length == 0 ? (
                  <div className="order-card-uslugi">
                    <Text size={_sizeText.m}>
                      {selected
                        ? "В данный момент нет активных заказов. Пожалуйста, проверьте архив или оформите новый заказ."
                        : "В архиве пусто, заказы попадают сюда при выполнении"}
                    </Text>
                  </div>
                ) : (
                  <>
                    {orders.map((item) => (
                      <OrderCardPreview
                        services={products}
                        order={item}
                        key={item["id"]}
                      />
                    ))}
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div >
  );
};
